import { MenuItem } from '@material-ui/core';
import { InputLabel, InputLabelProps, SxProps } from '@mui/material';
import TextField from '@mui/material/TextField';
import { IValueLabelPair } from 'models/Common';

interface IMuiSelectSingleChoice {
    id: string;
    label: string;
    size?: 'small' | 'medium' | undefined;
    onChange: (event: any) => void;
    value: string | number;
    type?: string;
    placeholder?: string;
    disabled?: boolean;
    options: any[];
    inputProps?: any;
    InputProps?: any;
    InputLabelProps?: Partial<InputLabelProps>;
    SelectProps?: any;
    menuItemsProps?: any;
    sx?: SxProps;
    fullWidth?: boolean;
    topLabel?: boolean;
}

export const MuiSelectSingleChoice = ({
    id,
    label,
    size,
    type,
    placeholder,
    onChange,
    value,
    disabled = false,
    options,
    inputProps,
    InputProps,
    InputLabelProps,
    SelectProps,
    menuItemsProps,
    sx,
    fullWidth,
    topLabel,
}: IMuiSelectSingleChoice) => {
    return (
        <>
            {topLabel && <InputLabel htmlFor={id}>{label}</InputLabel>}
            <TextField
                id={id}
                label={topLabel ? '' : label}
                variant="outlined"
                type={type}
                size={size}
                sx={sx}
                disabled={disabled}
                defaultValue=""
                placeholder={placeholder}
                autoComplete="off"
                onChange={onChange}
                value={value}
                inputProps={inputProps}
                InputProps={InputProps}
                InputLabelProps={InputLabelProps}
                select
                SelectProps={SelectProps}
                fullWidth={fullWidth}
            >
                {options.map((plan: IValueLabelPair) => (
                    <MenuItem key={plan.value} value={plan.value} classes={menuItemsProps}>
                        {plan.label}
                    </MenuItem>
                ))}
            </TextField>
        </>
    );
};
